// extracted by mini-css-extract-plugin
export var discard = "_4a-3";
export var muiTooltipTooltip = "_4a-5";
export var notificationBar = "_4a-2";
export var saveButtonHoverSlotWrapper = "_4a-4";
export var show = "_4a-1";
export var spacer = "_4a-0";